export default {
  top: { bottom: "top" },
  left: { right: "left" },
  right: { left: "right" },
  bottom: { top: "bottom" },
}
